import { useTranslation } from 'react-i18next';
import smallDog from '@assets/images/order-form-price-info-small.svg';
import middleDog from '@assets/images/order-form-price-info-middle.svg';
import bigDog from '@assets/images/order-form-price-info-big.svg';



const PriceInfo = () => {
	const { t } = useTranslation('forms');

	return (
		<div className='price-info-section'>

			<div className='info-text'>{t('priceInfo.sectionLabel')}</div>

			<div className='info-item small-size'>
				<p>{t('priceInfo.smallSize.title')}</p>
				<p>{t('priceInfo.smallSize.text')}</p>
				<img src={smallDog} alt='price-info-small-dog-image' />
			</div>

			<div className='info-item middle-size'>
				<p>{t('priceInfo.middleSize.title')}</p>
				<p>{t('priceInfo.middleSize.text')}</p>
				<img src={middleDog} alt='price-info-middle-dog-image' />
			</div>

			<div className='info-item big-size'>
				<p>{t('priceInfo.bigSize.title')}</p>
				<p>{t('priceInfo.bigSize.text')}</p>
				<img src={bigDog} alt='price-info-big-dog-image' />
			</div>

		</div>
	);
};

export default PriceInfo;